export const LOGIN_OTP = "LOGIN_OTP";
export const LOGOUT = "LOGOUT";
export const LOGIN_DATA = "LOGIN_DATA";
